<template>
    <div class="notification-dashboard">
        <div class="border bg-white rounded p-3" >
            <div class="header d-flex justify-content-between align-items-center mb-3">
                <h4 style="font-weight: 500; color:rgba(0, 0, 0, 1)" class="header__title--text">Thông báo</h4>
                <div style="font-weight: 500;" class="header__title--icon" v-if="notifications.length > 1">
                    <el-button style="" size="mini" @click="prevNotice">
                        <i class="el-icon-arrow-left pt-1"></i>
                    </el-button>
                    <el-button style="" size="mini" @click="nextNotice">
                        <i class="el-icon-arrow-right pt-1"></i>
                    </el-button>
                </div>
            </div>

            <div style="background-color: #FFFFFF;">
                <el-carousel ref="noticeCarousel" arrow="never" :interval="4000" height="200px">
                    <el-carousel-item  v-for="(item, key) in notifications" :key="key">
                        <router-link v-if="item.image" style="display: block;height: 100%;" target="_blank" :to="{ name: 'information-notification-slug',params: { slug: item.slug } }" title="Tin nổi bật Edutalk">
                            <img  :src="item.image" alt="item.image" class="w-100" style="border-radius: 5px; height: 100%; object-fit: contain;">
                        </router-link>
                        <router-link v-else style="display: block;height: 100%;" target="_blank" :to="{ name: 'information-notification-slug',params: { slug: item.slug } }">
                            <div class="p-3">
                                <h4>{{item.category}}</h4>
                                <h5 class="mb-2" style="font-weight: 500; color:#886ab5">Xem chi tiết</h5>
                            </div>
                        </router-link>
                    </el-carousel-item>
                    <div v-if="notifications.length === 0">Chưa có thông báo nào</div>
                </el-carousel>
            </div>
        </div>
    </div>
</template>
<script>
import {INFORMATION_INFORMATION} from "@/core/services/store/service.module";

export default {
    name: "NotificationDashboard",
    data() {
        return {
            notifications: [],
        };
    },
    props: {
        query: {
            type: Object,
            default: () => {
                return { is_dashboard: 1 }
            }
        }
    },
    methods: {
        nextNotice() {
            this.$refs.noticeCarousel.next();
        },
        prevNotice() {
            this.$refs.noticeCarousel.prev();
        },
        async getSpecialInformation() {
            let response = await this.$store.dispatch(INFORMATION_INFORMATION, this.query);
            this.notifications = response.data ?? [];
        }
    },
    mounted() {
        this.getSpecialInformation();
    },
};
</script>

<style scoped>
.notification-dashboard {

}
</style>
